import { Icon, Badge, Modal, Tabs, Scrollable, EmptyState, InlineStack, Text, BlockStack, InlineGrid, Card, Box, Button, Collapsible, SkeletonBodyText, List, Banner, Tooltip, Link, TextContainer } from '@shopify/polaris';
import { RiskMinor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import NoResultsFound from "../../../../Asests/Images/NoResultsFound.png";
import Noimage from '../../../../../public/files/noImage.png';
import { trim } from 'lodash';
import { GridApis } from '../Utilities/Apis';
import { capitalizeFirstLetter } from '../../Editproduct/components/ProductDetails/ProductErrors';
import { calculateTimeDifference, getLatestTime } from '../ListingGrid';

interface Props extends DIProps {
    errorModal: any;
    openErrorModal: any;
    errorData: any;
    activityRefreshAction: () => void
    ActivityProgress: any
    warningData: boolean,
    setWarningData: (data: boolean) => void
    t: (a: string) => any
}

//RESPONSIBLE FOR RENDERING ERROR MODAL ON PARENT AS WELL AS CHILD
const RenderErrorModal = (props: Props) => {
    const { errorModal, openErrorModal, t, errorData, activityRefreshAction, ActivityProgress, warningData, setWarningData } = props;
    const [openModal, setopenModal] = useState<boolean>(errorModal);
    const [ProductError, setProductError] = useState<string>('0')
    const [ProductWarning, setProductWarning] = useState<string>('0')
    const [childError, setchildError] = useState<any>(0)
    const [childWarning, setchildWarning] = useState<any>(0)
    const [templateError, setTemplateError] = useState(false);
    const [ErrorType, setErrorType] = useState<string>('')
    const [tabs, settabs] = useState<any>([])
    // FOR TAB WORKING
    const [selected, setSelected] = useState(0);

    // Function to handle the change event
    const handleChange = useCallback((data: any) => {
        setopenModal(!openModal); // Toggles the openModal state

        if (trim(data) == "image") {
            props.history(`./${errorData['container_id']}`, { replace: false, state: { attribute: data } });
        } else if (trim(data) == 'config') {
            props.history(`../config/productSettings/inventory`, { replace: false, state: { attribute: data } });
        }
        else if (ErrorType !== "") {
            // Switch statement to handle different error types
            switch (ErrorType) {
                case "Price":
                    // Redirects to the appropriate page based on the error type
                    if (errorData?.profile && Object.keys(errorData?.profile).length > 0) {
                        props.history(`../config/template/${errorData?.['profile']?.['profile_id']?.['$oid']}`, { replace: false, state: { attribute: data } });
                    } else {
                        props.history("../config/price", { replace: false, state: { attribute: data } });
                    }
                    break;
                case "Inventory":
                    if (errorData?.profile && Object.keys(errorData?.profile).length > 0) {
                        props.history(`../config/template/${errorData?.['profile']?.['profile_id']?.['$oid']}`, { replace: false, state: { attribute: data } });
                    } else {
                        props.history("../config/productSettings/inventory", { replace: false, state: { attribute: data } });
                    }
                    break;
                case "Image":
                case "Product":
                    if (errorData?.profile && Object.keys(errorData?.profile).length > 0) {
                        props.history(`../config/template/${errorData?.['profile']?.['profile_id']?.['$oid']}`, { replace: false, state: { attribute: data } });
                    } else {
                        props.history("../config/product", { replace: false, state: { attribute: data } });
                    }
                    break;
                default:
                    if (errorData?.profile && errorData?.profile.profile_id) {
                        props.history(`../config/template/${errorData?.['profile']?.['profile_id']?.['$oid']}`, { replace: false, state: { attribute: data } });
                    } else {
                        props.history(`./${errorData['container_id']}`, { replace: false, state: { attribute: data } });
                    }
                    break;
            }
        }


    }, [templateError, ErrorType]);


    const handleFixError = (message: string, errorValue: any) => {
        let data: any;

        if (!errorValue?.direct) {
            const regex: any = new RegExp(errorValue.regex_value)
            data = trim(regex.exec(message)[errorValue?.index]);
        } else {
            data = errorValue?.value;
        }




        handleChange(data);


    }


    useEffect(() => {
        openErrorModal(openModal);
    }, [openModal]);

    const handleTabChange = useCallback((selectedTabIndex: number) => setSelected(selectedTabIndex), []);

    useEffect(() => {
        let tabsData: any = [];
        if (props.errorData?.type === "simple") {
            tabsData.push({
                id: 'product-errors',
                content: (
                    <InlineStack blockAlign="center" gap="200">
                        <Text as='p'>{warningData ? t("Product warning(s)") : t("Product Error(s)")}</Text>
                        <Badge>{warningData ? ProductWarning : ProductError || "0"}</Badge>
                    </InlineStack>
                ),
                accessibilityLabel: 'Product Errors',
                panelID: 'product-orders-content-1',
            })
        } else {
            tabsData = [
                {
                    id: 'product-errors',
                    content: (
                        <InlineStack blockAlign="center" gap="200">
                            <Text as='p'>{warningData ? t("Product warning(s)") : t("Product Error(s)")}</Text>
                            <Badge>{warningData ? ProductWarning : ProductError || "0"}</Badge>
                        </InlineStack>
                    ),
                    accessibilityLabel: 'Product Errors',
                    panelID: 'product-orders-content-1',
                },
                {
                    id: 'variant-errors',
                    content: (
                        <InlineStack blockAlign="center" gap="200">
                            <Text as='p'>{warningData ? t("Variant warning(s)") : t("Variant Error(s)")}</Text>
                            <Badge>{warningData ? childWarning : childError}</Badge>
                        </InlineStack>
                    ),
                    accessibilityLabel: 'variant Errors',
                    panelID: 'variant-orders-content-1',
                },

            ]
        }

        settabs(tabsData)

    }, [props?.errorData, ProductError])

    //RENDER ERROR STATUS MODAL
    let allActivity = ActivityProgress?.["allActivity"]


    const ErrorRender: any = ({ key2 }: any) => {
        const [response1, setresponse] = useState<any>([])
        const [open, setOpen] = useState(false);

        const collapsableToggle = useCallback(() => setOpenCollapsable((open) => !open), []);
        // FOR COLLAPSIBLE WORKING
        const [openCollapsable, setOpenCollapsable] = useState(false);
        const [expanded, setexpanded] = useState(true);
        detectError(key2?.message)

        const handleToggle = (error: any) => {
            if (response1.length > 0) {
                setresponse([])
                setOpen(!open);
                setexpanded(!expanded)

            } else {
                setresponse([])
                setOpen(!open);
                setexpanded(!expanded)
                let data = {
                    "errorCode": error?.code.trim()
                }
                props.di.POST(GridApis.getErrorSolution, data).then((response: any) => {
                    if (response.success) {
                        setresponse(response?.data)
                        // Object.keys(response?.data).length > 0 && response?.data?.filter((response: any) => response?.solution_exists == true).length > 0 ? setresponse(response?.data?.filter((response: any) => response?.solution_exists == true)) : setresponse([{ 'answer': "No solution found, Kindly connect Support", 'noAnswer': true }])
                    } else {
                        setresponse([{ 'answer': "No solution found, Kindly connect Support", 'noAnswer': true }])
                    }
                }).catch((error) => console.error(error))

            }

        }
        let timeDifference = null;
        const latestTime = getLatestTime([key2?.time]);
        timeDifference = calculateTimeDifference(latestTime);

        return (
            <React.Fragment>
                <BlockStack gap={'100'}>
                    <InlineStack align='space-between' gap="100" wrap={false}>
                        <InlineStack gap="100" wrap={false}>
                            <div>
                                <Icon
                                    source={RiskMinor}
                                    tone="critical" />
                            </div>
                            {key2?.message?.length > 120 ?
                                <Box maxWidth='100%'>
                                    <InlineStack gap={"0"} wrap={false}>
                                        <InlineStack wrap={false} gap='0'>
                                            <Text as='h2'>{(key2?.code.includes("Amazon") || key2?.code.includes("amazon")) ? key2?.label ? `${key2?.label} :` : null : `${key2?.code ?? key2?.label} : ${' '}`}</Text>
                                            <Text alignment='start' as="p">
                                                {!openCollapsable ? key2?.message?.substring(0, 110) + "..." : key2?.message}
                                            </Text>
                                        </InlineStack>
                                        {!openCollapsable && <Button
                                            variant='plain'
                                            onClick={collapsableToggle}
                                            ariaExpanded={open}
                                            ariaControls="basic-collapsible"
                                        >   read more
                                        </Button>}
                                    </InlineStack>
                                </Box>

                                : <InlineStack gap='0'>
                                    <Text as='h2'>{(key2?.code.includes("Amazon") || key2?.code.includes("amazon")) ? key2?.label ? `${key2?.label} :` : null : `${key2?.code ?? key2?.label} : ${' '}`}</Text>
                                    <Text as="p">
                                        {key2?.message || 'N/A'}
                                    </Text>
                                </InlineStack>
                            }
                        </InlineStack>
                        {/* <Button
                        size="slim"
                        onClick={() => handleToggle(key2)}
                        ariaExpanded={open}
                        disclosure={
                            expanded ? 'down' : 'up'
                        }
                        ariaControls="basic-collapsible">
                        {open ? "Hide Solution" : "View Soluion"}
                    </Button> */}


                    </InlineStack>
                    {timeDifference?.hours && timeDifference?.hours > 1 ? <Text as='p' tone='subdued'><i>{`1 hour(s) ago`}</i></Text> : timeDifference?.minutes && timeDifference?.minutes > 0 ? <Text as='p' tone='subdued'><i>{`${timeDifference?.minutes} minute(s) ago`}</i></Text> : timeDifference?.seconds && timeDifference?.seconds > 0 && <Text as='p' tone='subdued'><i>{`${timeDifference?.seconds} seconds ago`}</i></Text>}
                </BlockStack>
                {/* <Collapsible
                    open={openCollapsable}
                    id="basic-collapsible"
                    transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                    expandOnPrint
                >
                    <Text alignment='justify' as="p">
                        {key2?.message || 'N/A'}
                    </Text>
                </Collapsible> */}

                <Collapsible
                    open={open}
                    id="basic-collapsible"
                    transition={{
                        duration: '500ms',
                        timingFunction:
                            'ease-in-out',
                    }}
                    expandOnPrint>
                    <div style={{ marginBottom: '10px' }}>
                        <Text as={'p'} >
                            <List type="bullet">
                                {response1.length > 0 ? response1.map((response: any) => {
                                    if (response?.noAnswer || !response?.solution) {

                                        return <Banner key={key2?.code} title='' tone='critical'>No Answer(s) Found!</Banner>
                                    }
                                    else {
                                        return <List.Item key={key2?.code}>
                                            <InlineStack wrap={false} gap="100" align='space-between' blockAlign="start" >
                                                <Text as='p' tone='subdued' > {response?.solution} </Text>
                                                <div style={{ flex: "none" }}>
                                                    <Button onClick={() => handleFixError(key2?.message, response)} variant="primary" size="slim">Fix now</Button>
                                                </div>
                                            </InlineStack>
                                        </List.Item>
                                    }
                                }) : <SkeletonBodyText />}
                            </List>
                        </Text>

                    </div>
                </Collapsible>

            </React.Fragment >
        );
    }

    // Function to detect and set the error type based on the error message
    const detectError = (error: string) => {
        if (error?.includes("Price") && error?.includes("Settings")) {
            setErrorType("Price");
        } else if (error?.includes("Inventory") && error?.includes("Settings")) {
            setErrorType("Inventory");
        } else if (error?.includes("Image") && error?.includes("Settings")) {
            setErrorType("Image");
        } else if (error?.includes("Product") && error?.includes("Settings")) {
            setErrorType("Product");
        } else {
            setErrorType("Edit");
        }
    };

    const RenderError = ({ error, setProductError, setTemplateError, setchildError, selected }: any) => {
        let varientsError: number = 0;
        let varientsWarning: number = 0;
        let parentError: any = 0;
        let parentWarning: any = 0;
        let renderError: any = [];

        error?.items?.forEach((err: any) => {
            const isSameProduct = err?.source_product_id === error?.source_product_id;
            if (!isSameProduct) {

                if (Object.keys(err)?.includes("error") && !warningData) {
                    if (err?.error?.constructor.name === "Array") {
                        varientsError += err?.error?.length;

                    } else if (err?.error?.constructor.name == "Object") {
                        Object.keys(err?.error).map((key: string) => {
                            varientsError += err?.error?.[key].length
                        })

                    }
                } else if (Object.keys(err)?.includes("warning") && warningData) {
                    varientsWarning += err?.warning?.length;
                }
            } else {

                if (Object.keys(err)?.includes("error") && !warningData) {
                    if (err?.error?.constructor.name === "Array") {
                        parentError += err?.error?.length;

                    } else if (err?.error?.constructor.name == "Object") {
                        Object.keys(err?.error).map((key: string) => {
                            parentError += err?.error?.[key].length
                        })
                    }
                } else if (Object.keys(err)?.includes("warning") && warningData) {
                    parentWarning += err?.warning?.length;
                }
            }
        });



        setProductError(parentError);
        setchildError(varientsError);
        setProductWarning(parentWarning);
        setchildWarning(varientsWarning);



        error?.items?.forEach((value: any) => {


            const isSameProduct = value?.source_product_id === error?.source_product_id;
            const image: React.ReactNode = <img width="100%" height="100%" src={value?.main_image || Noimage} alt="product" />


            if (selected === 0) {
                if (isSameProduct && Object.keys(value)?.includes("error") && !warningData) {
                    const groupedData: any = {};

                    if (value?.error?.constructor.name === "Array") {
                        value?.error?.forEach((item: any) => {
                            const type = item.type;
                            if (!groupedData[type]) {
                                groupedData[type] = [];
                            }
                            groupedData[type].push(item);
                        });
                    }
                    else if (value?.error?.constructor.name == "Object") {
                        let test: any = Object.entries(value.error).map(([type, messages]: any) =>
                            messages.map((message: string) => ({
                                type,
                                code: "AmazonError501",
                                message
                            }))
                        ).reduce((acc, val) => acc.concat(val), [])
                        test.forEach((item: any) => {
                            const type = item.type;
                            if (!groupedData[type]) {
                                groupedData[type] = [];
                            }
                            groupedData[type].push(item);
                        });
                    }
                    renderError.push(<Box padding="500" >
                        <BlockStack gap="300">
                            <InlineStack gap='200' blockAlign='center'>
                                <div className="error-product-img-container">
                                    {image}
                                </div>
                                <Text as='p' fontWeight='semibold'>{value?.title ?? ''}</Text>
                            </InlineStack>

                            {Object.keys(groupedData).map((key: any, count: number) => {
                                return (<BlockStack key={count} gap="400">
                                    <Text as='h2' variant='headingSm'>{`${capitalizeFirstLetter(key)} ${warningData ? 'warning(s)' : 'error(s)'}`}</Text>

                                    {Object.values(groupedData[key]).map((data: any, count) => {
                                        return (
                                            <ErrorRender key={data.code} key2={data} />)
                                    })}
                                </BlockStack>)
                            })}
                        </BlockStack>
                    </Box>)

                } else if (warningData && isSameProduct && Object.keys(value)?.includes("warning")) {
                    const groupedData: any = {};
                    value.warning.forEach((item: any) => {
                        const type = item.type;
                        if (!groupedData[type]) {
                            groupedData[type] = [];
                        }
                        groupedData[type].push(item);
                    });
                    renderError.push(<Box padding="500">
                        <BlockStack gap="300">
                            <InlineStack gap='200' blockAlign='center'>
                                <div className="error-product-img-container">
                                    {image}
                                </div>
                                <Text as='p' fontWeight='semibold'>{value?.title ?? ''}</Text>
                            </InlineStack>

                            {Object.keys(groupedData).map((key: any, count: number) => {
                                return (<BlockStack key={count} gap="400">
                                    <Text as='h2' variant='headingSm'>{`${capitalizeFirstLetter(key)} ${warningData ? 'warning(s)' : 'error(s)'}`}</Text>

                                    {Object.values(groupedData[key]).map((data: any, count) => {
                                        return (
                                            <ErrorRender key={data.code} key2={data} />)
                                    })}
                                </BlockStack>)
                            })}
                        </BlockStack>
                    </Box>)
                }

            }
            if (selected === 1) {
                if (!isSameProduct && Object.keys(value)?.includes("error") && !warningData) {

                    const groupedData: any = {};
                    if (value?.error?.constructor.name === "Array") {
                        value?.error?.forEach((item: any) => {
                            const type = item.type;
                            if (!groupedData[type]) {
                                groupedData[type] = [];
                            }
                            groupedData[type].push(item);
                        });
                    }
                    else if (value?.error?.constructor.name == "Object") {
                        let test: any = Object.entries(value.error).map(([type, messages]: any) =>
                            messages.map((message: string) => ({
                                type,
                                code: "AmazonError501",
                                message
                            }))
                        ).reduce((acc, val) => acc.concat(val), [])
                        test.forEach((item: any) => {
                            const type = item.type;
                            if (!groupedData[type]) {
                                groupedData[type] = [];
                            }
                            groupedData[type].push(item);
                        });
                    }

                    renderError.push(<Box padding="500" >
                        <BlockStack gap="300">
                            <InlineStack gap='200' blockAlign='center'>
                                <div className="error-product-img-container">
                                    {image}
                                </div>
                                <Text as='p' fontWeight='semibold'>{value?.sku ?? ''}</Text>
                            </InlineStack>

                            {Object.keys(groupedData).map((key: any, count: number) => {
                                return (<BlockStack key={count} gap="400">
                                    <Text as='h2' variant='headingSm'>{`${capitalizeFirstLetter(key)} ${warningData ? 'warning(s)' : 'error(s)'}`}</Text>

                                    {Object.values(groupedData[key]).map((data: any, count) => {
                                        return (
                                            <ErrorRender key={data.code} key2={data} />)
                                    })}
                                </BlockStack>)
                            })}
                        </BlockStack>
                    </Box>)
                } else if (warningData && !isSameProduct && Object.keys(value)?.includes("warning")) {

                    const groupedData: any = {};
                    value.warning.forEach((item: any) => {
                        const type = item.type;
                        if (!groupedData[type]) {
                            groupedData[type] = [];
                        }
                        groupedData[type].push(item);
                    });
                    renderError.push(<Box padding="500">
                        <BlockStack gap="300">
                            <InlineStack gap='200' blockAlign='center'>
                                <div className="error-product-img-container">
                                    {image}
                                </div>
                                <Text as='p' fontWeight='semibold'>{value?.title ?? ''}</Text>
                            </InlineStack>

                            {Object.keys(groupedData).map((key: any, count: number) => {
                                return (<BlockStack key={count} gap="400">
                                    <Text as='h2' variant='headingSm'>{`${capitalizeFirstLetter(key)} ${warningData ? 'warning(s)' : 'error(s)'}`}</Text>

                                    {Object.values(groupedData[key]).map((data: any, count) => {
                                        return (
                                            <ErrorRender key={data.code} key2={data} />)
                                    })}
                                </BlockStack>)
                            })}
                        </BlockStack>
                    </Box>)
                }

            }

        });

        return renderError.length > 0 ? renderError : (
            <EmptyState
                image={NoResultsFound}
                heading={"No Error found!"}
            />
        );
    };

    const [secondaryAction, setSecondaryAction] = useState<any>([]);

    useEffect(() => {
        handleSecondaryAction()
    }, [])

    const handleSecondaryAction = () => {
        let temp: any = [];
        let obj: any = {};
        if (allActivity !== undefined) {
            obj = {
                content: 'Refresh to update status',
                onAction: () => { setopenModal(false); activityRefreshAction() },
            }
        }
        else {
            obj = {
                content: 'Cancel',
                onAction: () => setopenModal(false),
            }
        }
        temp.push(obj)

        setSecondaryAction([...temp])
    }

    return (
        <Modal
            open={openModal}
            footer={<Box><Text as='p'>
                Can’t find the solution? Contact us through {" "}<Link url={`mailto:support@cedcommerce.com?subject=${encodeURIComponent(`${props?.di?.globalState?.get("username") ?? props?.redux?.current?.source?.name ?? "Seller"} has a question about ${process.env.REACT_APP_NAME_AND_ENV ?? "Cedcommerce Amazon Channel"}`)}`} target='_blank'>Email</Link>
            </Text></Box>}
            onClose={() => { setopenModal(false); setWarningData(false) }}
            size='large'
            title={allActivity !== undefined ? ActivityProgress.title : t("Errors")}
            primaryAction={
                undefined
            }
            secondaryActions={
                undefined
            }>
            <Card padding='0' >
                {
                    (allActivity === undefined) ? null :
                        (
                            Object.keys(allActivity).map((activity: any, counter: number) => {
                                return (
                                    <Box key={counter} padding="500">
                                        <InlineGrid gap="400" columns='2'>
                                            <BlockStack gap="100">
                                                <Text as='p' fontWeight="semibold">{renderActivityMsg(allActivity?.[activity]?.['msg'])}</Text>
                                                <Text as='p' tone='subdued'>{allActivity?.[activity]?.['time']}</Text>
                                            </BlockStack>
                                            <Text as='p' tone='subdued'><em>{allActivity?.[activity]?.['msg']}</em></Text>
                                        </InlineGrid>
                                    </Box>
                                );
                            })
                        )
                }
                <Tabs
                    tabs={tabs}
                    selected={selected}
                    onSelect={handleTabChange}>
                    <Scrollable shadow style={{ height: '300px' }}>
                        <RenderError setTemplateError={setTemplateError} error={errorData} setProductError={setProductError} setchildError={setchildError} selected={selected} ></RenderError>
                    </Scrollable>
                </Tabs>
            </Card>
        </Modal>
    );
};

export const renderActivityMsg = (msg: string) => {
    let activity: string = "";
    switch (msg) {
        case "Inventory Sync Initiated":
            activity = "Inventory Sync"
            break;
        case "Product Upload Initiated":
            activity = "Product Upload"
            break;
        case "Sync Product Initiated":
            activity = "Product Sync"
            break;
        case "Image Sync Initiated":
            activity = "Image Sync"
            break;
        case "Price Sync Initiated":
            activity = "Price Sync"
            break;
        case "Product Delete Initiated":
            activity = "Product Delete"
            break;
        case "Inventory Feed Submitted":
            activity = "Inventory Sync"
            break;
        case "Product Feed Submitted":
            activity = "Product Upload"
            break;
        case "Sync Product Feed Submitted":
            activity = "Product Sync"
            break;
        case "Image Feed Submitted":
            activity = "Image Sync"
            break;
        case "Price Feed Submitted":
            activity = "Price Sync"
            break;
        case "Product Delete Feed Submitted":
            activity = "Product Delete"
            break;
        default:
            activity = ""
    }
    return activity
}

export default DI(RenderErrorModal)